<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/order-templates/shared/product-add-to-order-template/product-add-to-order-template.component.ts
-->
<ng-template #anchor></ng-template>
